


























import Vue, { PropType } from 'vue'
import type { FormState, FormLabels } from '../UiForm.types'
import UiButton from '../../UiButton'
export default Vue.extend({
  name: 'UiFormCta',
  components: {
    UiButton
  },
  props: {
    state: {
      type: [Object, Boolean] as PropType<FormState>,
      default: false
    },
    i18n: {
      type: Object as PropType<FormLabels>,
      required: true
    }
  }
})
